import { render, staticRenderFns } from "./icon-attributes.vue?vue&type=template&id=3c902272"
import script from "./icon-attributes.vue?vue&type=script&lang=js"
export * from "./icon-attributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports